<template>
    <div v-if="active" class="fixed z-10 bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
        <div class="fixed inset-0 transition-opacity" @click="close()">
            <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>
        <div id="modal" class="rounded-sm px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full sm:p-6" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
            <div>
                <div class="mt-3 sm:mt-5">
                    <h3 class="modal-title text-2xl leading-6 font-medium" id="modal-headline">
                        {{$t('translations.components.modal-table-close-confirm.title')}}
                    </h3>
                    <div class="mt-2">
                        <p class="text-base leading-5">
                            {{$t('translations.components.modal-table-close-confirm.question')}}
                        </p>
                    </div>
                </div>
            </div>
            <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <span class="flex w-full rounded-sm shadow-sm sm:col-start-2">
                    <a @click="save()" class="button button-large button-primary w-full">
                        {{$t('translations.components.modal-table-close-confirm.save')}}
                    </a>
                </span>
                <span class="mt-3 flex w-full rounded-sm shadow-sm sm:mt-0 sm:col-start-1">
                    <a @click="discard()" class="button button-large button-danger w-full">
                        {{$t('translations.components.modal-table-close-confirm.discard')}}
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalTableCloseConfirm',
    data () {
        return {
            active: false,
        }
    },
    methods: {
        open() {
            this.active = true
        },
        close() {
            this.active = false
        },
        save() {
            this.$emit('save')
            this.close()
        },
        discard() {
            this.$emit('discard')
            this.close()
        },
    },
}
</script>
